import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './views/app'
import storage from '../services/storage'
import * as Sentry from '@sentry/browser'

const el = document.getElementById('cart-app')

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: el.dataset.sentryDsn,
    environment: process.env.NODE_ENV
  })
}

storage.setItem('cartId', el.dataset.cartid)

const root = createRoot(el)
root.render(<App checkoutPath={el.dataset.checkoutPath} />)
